import { render, staticRenderFns } from "./LikeIconV3.vue?vue&type=template&id=57c40e02&"
import script from "./LikeIconV3.vue?vue&type=script&lang=js&"
export * from "./LikeIconV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports